import React from "react";
import { Link } from "react-router-dom";

import { Button, makeStyles } from "@material-ui/core";
import { ArrowRight as ArrowRightIcon } from "@material-ui/icons";

const useSmartUploadStyles = makeStyles((theme) => ({
  link: { textDecoration: "none", color: "black", marginLeft: theme.spacing(1) }
}));

export const SmartUploadButton = ({ numSelected, onSubmit }) => {
  const classes = useSmartUploadStyles();
  const disabled = !numSelected || numSelected < 1;

  return (
    <Link className={classes.link} to="/smart">
      <Button
        variant="outlined"
        color="secondary"
        aria-label="smart traffick"
        disabled={disabled}
        endIcon={<ArrowRightIcon />}
        disableElevation
        onClick={onSubmit}
      >
        Smart Traffick
      </Button>
    </Link>
  );
};
